export default __webpack_public_path__ + "static/media/e_jesterka_obecna-min.85e80851.jpg";